// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64(),
  worldId: __t.u64().name("world_id"),
  fromHero: __t.u64().name("from_hero"),
  fromOwner: __t.identity().name("from_owner"),
  toHero: __t.u64().name("to_hero"),
  toOwner: __t.identity().name("to_owner"),
  giveItems: __t.array(__t.u64()).name("give_items"),
  giveGold: __t.u32().name("give_gold"),
  askItems: __t.array(__t.u64()).name("ask_items"),
  askGold: __t.u32().name("ask_gold"),
  note: __t.string(),
  state: __t.u8(),
  reason: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  settledAt: __t.option(__t.timestamp()).name("settled_at"),
});
